import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "@heroicons/react/16/solid";
import { AppointmentList } from "@/features/patient/appointments/components/index/appointment-list";

const PatientAppoinments = () => {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <div className="mb-4 flex flex-wrap">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your appointments
                    </h1>
                    <Button asChild className="md:ms-auto">
                        <Link to="/clinicians/find">
                            <PlusIcon className="stroke-2" />
                            Book appointment
                        </Link>
                    </Button>
                </div>
                <AppointmentList />
            </div>
        </div>
    );
};

export default PatientAppoinments;
